// English is the source of truth; other locales must provide every key.
export const en = {
  attendeeExport: {
    download: "Download CSV", preparing: "Preparing CSV…", failed: "The export could not be prepared. Please try again.",
    retry: "Prepare CSV", scope: "Website member registrations only. Guest registrations remain in HubSpot.",
  },
  eventText: {
    title: "Event text", facts: "Event details", invitation: "Invitation", description: "Event description", recap: "Event recap",
    format: "Text type", language: "Language", generate: "Generate text", generating: "Generating…", stop: "Stop",
    apply: "Use as description", result: "Draft text", applied: "Draft added to the description. Save the event to keep it.",
    invalid: "Enter a title and at least 10 characters of event details.", failed: "The text could not be generated. Please try again later.",
    confirmReplace: "Replace the current description with this draft?", stopped: "Generation stopped. The partial draft has been kept.",
    accessRestored: "Access restored", resume: "Access or credits restored — enable generation", review: "Review the facts before saving. Generation uses workspace AI credits.",
  },
  eventAddress: {
    label: "Event web address",
    automatic: "Automatic address",
    invalid: "Use lowercase letters, numbers and hyphens only; start with a letter or number.",
    taken: "This web address is already in use. Please choose another.",
    changed: "Previously shared links will stop working after you save the new address.",
  },
  eventActions: {
    edit: "Edit event", delete: "Delete event", cancel: "Cancel", loading: "Loading event…",
    unavailable: "This event could not be loaded for editing. Please try again.",
    confirmDelete: "Delete this event?", deleting: "Deleting…",
    deleteFailed: "The event could not be deleted. Please try again.",
  },
  guestAdmin: {
    showPassword: "Show password", hidePassword: "Hide password",
    title: "Guest access", loading: "Loading guest access…", unavailable: "Guest access could not be loaded. Please try again.",
    password: "New event password", active: "Password set", absent: "No password set", save: "Save password", remove: "Remove password",
    saved: "Password saved.", removed: "Password removed.", invalid: "Enter a password between 6 and 128 characters.",
    failed: "The change could not be saved. Please try again.", busy: "Saving…", days: "Guest access valid for", custom: "Custom (days)", until: "valid until", dayUnit: "day", daysUnit: "days", appliesTo: "Applies to the password and the guest link. Maximum 30 days.",
    renew: "Renew validity", renewed: "Guest access validity renewed.", expiry: "Valid until", expired: "Guest access expired.",
    disabled: "Guest access is disabled.", rotate: "Replace guest link", confirmRotate: "Replace the guest link? Previously shared links will stop working.",
    confirmRemove: "Remove the event password?", rotated: "Guest link replaced.", link: "Guest link", copy: "Copy guest link", copied: "Guest link copied.",
    unpublished: "No published article is available for this guest link.", saveFirst: "Save the event before managing guest access.",
  },
  contact: {
    title: "Contact the Secretariat",
    email: "E-mail the Secretariat",
    phone: "Call the Secretariat",
  },
  registration: {
    title: "Registration",
    password: "Event password",
    unlock: "Continue",
    checking: "Checking…",
    loading: "Loading registration…",
    unavailable: "Registration could not be loaded. Please try again or contact the organiser.",
    denied: "Access could not be verified. Please check your event password or contact the organiser.",
    expired: "This guest access has expired. Please contact the organiser.",
    sending: "Sending your registration… please wait.",
  },
  nav: {
    home: "Home",
    allMeetings: "All Meetings",
    initiatives: "Initatives",
    newDiplomats: "New Diplomats",
    femaleLeaders: "Female Leaders Initiative",
    diplomaticCircle: "The Diplomatic Circle",
    about: "About",
    contact: "Contact",
    members: "Members",
    membersArea: "Members Area",
    login: "Login",
    logout: "Logout",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    language: "Language",
  },
  footer: {
    imprint: "Imprint",
    privacy: "Privacy policy",
    copyright: "© Copyright Foreign Council On Economic Relations",
  },
  notFound: {
    title: "Page not found",
    text: "The page you're looking for doesn't exist or has been moved.",
    home: "Go home",
  },
};

export type Messages = typeof en;
